import { ago } from "../time";
import type { Invitation, Member, Organization, Project, User } from "../types/common";

/**
 * The fixture tenant. Northwind is a sales-engagement product whose users
 * connect their own mailbox, calendar and address book — the shape of an Aux0
 * customer, so every screen reads as a real account rather than a demo.
 */
export const ORG: Organization = {
  id: "org_nw",
  name: "Northwind",
  slug: "northwind",
  plan: "growth",
  createdAt: ago(34, "w"),
};

export const PROJECTS: Project[] = [
  {
    id: "prj_main",
    orgId: ORG.id,
    name: "Northwind Sales",
    slug: "sales",
    environments: ["sandbox", "production"],
    createdAt: ago(34, "w"),
  },
  {
    id: "prj_recruit",
    orgId: ORG.id,
    name: "Northwind Recruit",
    slug: "recruit",
    environments: ["sandbox", "production"],
    createdAt: ago(9, "w"),
  },
];

export const CURRENT_USER: User = {
  id: "usr_dev",
  name: "Priya Shah",
  email: "priya@northwind.io",
};

export const MEMBERS: Member[] = [
  {
    ...CURRENT_USER,
    role: "owner",
    joinedAt: ago(34, "w"),
    lastSeenAt: ago(3, "m"),
  },
  {
    id: "usr_eng",
    name: "Tom Okafor",
    email: "tom@northwind.io",
    role: "admin",
    joinedAt: ago(30, "w"),
    lastSeenAt: ago(2, "h"),
  },
  {
    id: "usr_be",
    name: "Lena Fischer",
    email: "lena@northwind.io",
    role: "developer",
    joinedAt: ago(21, "w"),
    lastSeenAt: ago(1, "d"),
  },
  {
    id: "usr_ops",
    name: "Dan Whitfield",
    email: "dan@northwind.io",
    role: "developer",
    joinedAt: ago(11, "w"),
    lastSeenAt: ago(5, "h"),
  },
  {
    id: "usr_fin",
    name: "Aisha Kone",
    email: "aisha@northwind.io",
    role: "viewer",
    joinedAt: ago(6, "w"),
    lastSeenAt: ago(4, "d"),
  },
];

export const INVITATIONS: Invitation[] = [
  {
    id: "inv_1",
    email: "marco@northwind.io",
    role: "developer",
    invitedBy: CURRENT_USER.name,
    invitedAt: ago(2, "d"),
    expiresAt: ago(-5, "d"),
  },
];
